<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { todosModalItemStore } from "../stores";

  $: href = $todosModalItemStore?.data.url || "";
</script>

<ButtonWithTooltip
  kind="primary"
  leadingIcon="fa-brands fa-linkedin"
  class="flex-1"
  {href}
  target="_blank"
  size="large"
  placement="top"
>
  <span slot="tooltip"
    >Manually send InMail on <br />LinkedIn to continue outreach</span
  >
  Send InMail
</ButtonWithTooltip>
